var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('div',{class:_vm.$style.left},[_vm._t("left")],2),_c('div',{class:_vm.$style.center},[_vm._t("center")],2),_c('div',{class:_vm.$style.right},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }